import newsdesk from './newsdesk'
import pcc from './pcc'
import nrcs from './nrcs'
import preferences from './preferences'
import boundaries from './boundaries'
import dashboard from './dashboard'
import docker from './docker'
import uploader from './uploader'
import archiveRundowns from './archiveRundowns'
import roles from './roles'
import storyHub from './storyHub'
import aiAgentChat from './aiAgentChat'
import sequences from './sequences'

export default {
  newsdesk,
  pcc,
  nrcs,
  boundaries,
  dashboard,
  docker,
  preferences,
  uploader,
  archiveRundowns,
  roles,
  storyHub,
  aiAgentChat,
  sequences
}
